import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { RadioButton } from "@similarweb/ui-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 6px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0 !important;
    flex-direction: column !important;
`;

export const Title = styled.h2`
    margin: 0;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const Tag = styled.span`
    display: flex;
    align-items: center;
    height: 12px;
    padding: 2px 8px;
    border-radius: 19px;
    background-color: ${colorsPalettes.blue[400]};
    ${setFontVariant("caption2", colorsPalettes.bluegrey[100])};
`;

export const Description = styled.span`
    display: flex;
    flex-direction: row;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;
